import '../vendor/jquery.cookie';

import logEvent from 'app/assets/javascripts/tracking/amplitude/log-event';
import scribdAuthorize from '../scribd/scribd_oauth.js';

$(function () {
  'use strict';
  const slideshare_object = window.slideshare_object;
  const utils = window.slideshare_object.utils;

  function logDownloadEventToAmplitude(slideshow, eventName, eventSource) {
    var eventOptions = {
      slideshow_id: slideshow.id,
      slideshow_created_at: slideshow.createdAt,
      slideshow_language: slideshow.language,
      slideshow_format: slideshow.format,
      source: eventSource || window.location.pathname,
    };

    logEvent(eventName, eventOptions);
  }

  function isUserAuthenticated() {
    return utils.isUserAuthenticated();
  }

  function getDateTimeTwoMinutesFromNow() {
    const TWO_MINUTES = 2 * 60 * 1000;
    var date = new Date();

    return date.setTime(date.getTime() + TWO_MINUTES);
  }

  function showAlertModal(alertText) {
    var alertModal = $('#alert-modal');
    alertModal.find('p').html(alertText);
    alertModal.foundation('reveal', 'open');
  }

  function showAlert() {
    var downloadingAlert = $('#j-downloading-alert');

    downloadingAlert.show();
    setTimeout(function () {
      downloadingAlert.hide();
    }, 3000);
  }

  function downloadFile(downloadButton, slideshow, automatic) {
    var downloadUrl = downloadButton.data('download');
    var downloadEventSource = downloadButton.data('event-tracking-source');
    downloadButton.attr('disabled', true);

    $.post(downloadUrl, function (data) {
      // Whether to reenable the downloadButton at the end of the function
      var enableDownloadButton = true;
      if (data.success && data.url) {
        showAlert();
        logDownloadEventToAmplitude(
          slideshow,
          'slideshow_download_init',
          downloadEventSource
        );

        const iframe = document.createElement('iframe');
        iframe.src = data.url;
        iframe.style.display = 'none';

        document.body.appendChild(iframe);
      } else if (data.action == 'error') {
        // Display the error from the result
        showAlertModal(data.error);
      } else if (data.action == 'subscription_required' && !automatic) {
        redirectToScribd(slideshow);
      }
      if (enableDownloadButton) {
        // re-enable download button
        downloadButton.removeAttr('disabled');
      }
    });
  }

  function redirectToScribd(slideshow, additional_params = '') {
    const slideshowKey =
      slideshare_object.slideshow &&
      slideshow.id == slideshare_object.slideshow.id
        ? slideshare_object.key
        : undefined;

    $.cookie('logout_action', 'save', {
      path: '/',
      expires: getDateTimeTwoMinutesFromNow(),
    });

    scribdAuthorize({
      from_source: `${slideshow.url}?from_action=save${additional_params}`,
      slideshow_id: slideshow.id,
      slideshow_key: slideshowKey,
      isDownload: true,
    });
  }

  function getSlideshowDataFromButton(button) {
    var slideshow = slideshare_object.slideshow;

    // Slideshow object is available on the slideshow page, but not on the index page
    // For the index & list pages, we grab data from the download button
    if (slideshow) {
      return {
        id: slideshow.id,
        url: slideshow.ss_url,
        createdAt: slideshow.created_at,
        category: slideshare_object.gam_cat_name,
        language: slideshow.language,
        format: slideshow.type,
        subscriptionRequired: slideshow.subscription_required,
      };
    } else {
      var id = $(button).attr('data-ssid');
      var url = $(button).attr('data-ss-url');
      var createdAt = $(button).attr('data-ss-created-at');
      var language = $(button).attr('data-ss-language');
      var format = $(button).attr('data-ss-format');
      var subscriptionRequired =
        $(button).attr('data-subscription-required') === 'true';

      return {
        id: id,
        url: url,
        createdAt: createdAt,
        language: language,
        format: format,
        subscriptionRequired: subscriptionRequired,
      };
    }
  }

  function handleDownload(e) {
    e.preventDefault();
    e.stopPropagation();

    const downloadButton = $(this);
    const slideshow = getSlideshowDataFromButton(downloadButton);
    var downloadEventSource = $(downloadButton).data('event-tracking-source');

    logDownloadEventToAmplitude(
      slideshow,
      'slideshow_download_attempt',
      downloadEventSource
    );

    if (isUserAuthenticated()) {
      downloadFile(downloadButton, slideshow, false);
    } else {
      redirectToScribd(slideshow);
    }
  }

  $('[data-download]').click(handleDownload);

  // Wrapped into $(function() { .. }) to run after CSRF setup.
  // jQuery is junky
  $(function () {
    $('[data-download-start-automatically]').each(function () {
      var slideshow = getSlideshowDataFromButton($(this));
      downloadFile($(this), slideshow, true);
    });
  });
});
